import { render, staticRenderFns } from "./CallCenterContatto.vue?vue&type=template&id=8c762436&"
import script from "./CallCenterContatto.vue?vue&type=script&lang=ts&"
export * from "./CallCenterContatto.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports